'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _utils = require('../utils');

var _HeroLoader = require('../vue/components/HeroLoader.vue');

var _HeroLoader2 = _interopRequireDefault(_HeroLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VueHeroLoader = function VueHeroLoader(el) {
  (0, _classCallCheck3.default)(this, VueHeroLoader);

  var checkHeroLoader = function checkHeroLoader() {
    if (window.innerWidth > _utils.mediaBreakpoints.sm) {
      window.setTimeout(function () {
        new _vue2.default({
          components: {
            HeroLoader: _HeroLoader2.default
          },

          data: function data() {
            return {
              images: el.dataset.images.split('|'),
              mobileImage: el.dataset.mobileImage
            };
          }
        }).$mount(el);
      }, 0);
    }
  };

  checkHeroLoader();

  window.addEventListener('resize', (0, _utils.debounce)(checkHeroLoader, 50));
};

exports.default = VueHeroLoader;